<template>
    <div v-if="!state.isLoading">
        <div v-if="matchName !== ''" class="w-full flex justify-center">
            <span
                class="text-center text-lg shadow-none w-full min-w-fit mt-[-1rem] h-fit font-semibold text-black-600">
                {{ matchName }} </span>
        </div>
        <div class="grid xl:grid-cols-3 grid-cols-2 h-max gap-x-4 text-[#243045]">
            <div class="xl:col-span-1 col-span-2 h-full mt-2">
                <div class="m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5">
                    <div v-if="match.id" class="w-full flex justify-center">
                        <label for="matchId" class="font-bold block mb-2 text-center min-w-max px-2 w-1/3"> Match
                            Id:
                        </label>
                        <InputText v-model="match.id" class="text-left shadow-none h-6 w-2/3" disabled />
                    </div>
                    <div class="flex 2xl:flex-row xl:flex-col md:flex-row flex-col w-full items-center">
                        <div class="flex w-full">
                            <label class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Result: </label>
                            <Dropdown v-model="match.result" :options="result" placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 "
                                :disabled="!state.isEditMode" />
                        </div>
                        <div class="flex w-full mb-1.5">
                            <div class="card flex wrap-none justify-center m-auto w-2/3 max-w-min">
                                <SelectButton v-model="match.gender" :options="genderOptions"
                                    :disabled="!state.isEditMode" :allowEmpty="false"
                                    :pt="{ button: { class: ['py-0 px-1 bg-[#e5e7eb] border rounded-md m-0.5 w-[80px] text-sm'] }, }"
                                    class="toss-decision bg-[#e5e7eb] rounded-md " />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5">
                    <div class="flex mb-4">

                        <label class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Start Date:
                            <span v-if="!state.isValid && !match.startDate"
                                class="text-red-500 text-xs pl-1 flex w-full justify-center font-normal">
                                Please fill in this field
                            </span>
                        </label>
                        <Calendar v-model="match.startDate" @update:model-value="updateName()" showTime
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 self-center" showIcon
                            :disabled="!state.isEditMode" />
                    </div>
                    <div class="flex mb-4">
                        <label class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Finish Date: </label>
                        <Calendar v-model="match.finishDate"
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6" showIcon
                            :disabled="!state.isEditMode" />
                    </div>
                    <div class="flex">
                        <label class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Match Days: </label>
                        <Calendar v-model="match.matchDays" dataFormat="yy-mm-dd"
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6" showIcon
                            :disabled="!state.isEditMode" selectionMode="multiple" />
                    </div>
                </div>
                <div class="m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5">
                    <div class="flex mb-4">
                        <label for="series" class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Series:
                        </label>
                        <InputText v-model="match.series.name" placeholder=""
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 "
                            :disabled="!state.isEditMode" />
                    </div>
                    <div class="flex mb-4">
                        <label for="season" class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Season:
                        </label>
                        <Dropdown v-model="match.season" :options="season" placeholder=""
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 "
                            :disabled="!state.isEditMode" />
                    </div>
                    <!-- <div class="flex mb-4">
                        <label for="matchRules" class="font-bold block mb-2 w-1/3 text-center min-w-max px-2"> Match
                            Rules:
                        </label>
                        <Dropdown v-model="match.matchRules" :options="matchRules" placeholder=""
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 "
                            :disabled="!state.isEditMode" />
                    </div> -->
                    <div class="flex">
                        <label for="startType" class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Match Type:
                        </label>
                        <Dropdown v-model="match.matchType" :options="matchType" placeholder=""
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 "
                            :disabled="!state.isEditMode" />
                    </div>
                    <!-- Day / Night -->
                    <!-- <div class="flex">
                        <label for="dayNight" class="font-bold block mb-2 w-1/3 text-center min-w-max px-2">Day Night:
                        </label>
                        <Dropdown v-model="match.dayNight" :options="dayNight" placeholder=""
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 "
                            :disabled="!state.isEditMode" />
                    </div> -->
                </div>
                <div
                    class="m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5 justify-center items-center flex">
                    <label for="season"
                        class="font-bold block w-1/3 text-center min-w-max px-2 h-full self-center mb-2"> Ground:
                        <span v-if="!state.isValid && !match.venue.id"
                            class="text-red-500 text-xs pl-1 flex w-full justify-center font-normal">
                            Please fill in this field
                        </span>
                    </label>
                    <div class="flex flex-col w-2/3 items-end mb-2">

                        <Dropdown v-model="match.venue" :options="ground" filter optionLabel="name"
                            placeholder="Stadium Name" @update:model-value="updateName()"
                            class="text-center rounded-md border-2 shadow-none w-full min-w-fit h-6 "
                            :disabled="!state.isEditMode" />
                        <!-- North and South End venue info -->
                        <!-- <InputText v-model="match.ground.northEnd" placeholder="North End"
                            class=" text-center rounded-md border-2 shadow-none w-full min-w-fit h-6 mb-2 m-0.5"
                            :disabled="!state.isEditMode" />
                        <InputText v-model="match.ground.southEnd" placeholder="South End"
                            class=" text-center rounded-md border-2 shadow-none w-full min-w-fit h-6 mb-2 m-0.5"
                            :disabled="!state.isEditMode" /> -->
                    </div>
                </div>
                <!-- Boundaries -->
                <!-- <div class="m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-0.5 justify-center items-center">
                    <label for="season" class="font-bold block w-full text-center min-w-max px-2 ">Boundary:
                    </label>
                    <div class="flex flex-wrap boundary">
                        <div v-for="value, key in match.boundary" :key="key"
                            class="w-1/2 flex justify-around p-0.5 pb-2">
                            <label :for="key" class="font-semibold text-center text-sm block min-w-max w-10">
                                {{ key.charAt(0).toUpperCase() + key.slice(1) }}:
                            </label>
                            <InputNumber v-model="match.boundary[key]" :minFractionDigits="0" :maxFractionDigits="2"
                                :inputId="key" class="rounded-md border-2 shadow-none h-6 w-1/2" suffix="m"
                                :disabled="!state.isEditMode" />
                        </div>
                    </div>
                </div> -->
                <div
                    class="m-4 mb-0 border-2 border-[#e5e7eb] rounded-lg border-solid p-0.5 justify-center items-center">
                    <div class="flex mb-2 mt-1">
                        <label class="font-bold block w-1/3 text-center content-center min-w-max px-2">Toss Winner:
                        </label>
                        <Dropdown v-model="match.toss" :options="tossWinnerOptions" optionLabel="name" placeholder=""
                            :disabled="!state.isEditMode"
                            class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mr-1" />
                    </div>
                    <div class="flex mb-1">
                        <label class="font-bold block w-1/3 text-center content-center min-w-max px-2"> Toss Decision:
                        </label>
                        <div class="card flex wrap-none justify-center m-auto">
                            <SelectButton v-model="match.tossDecision" :options="tossDecisionOptions"
                                :disabled="!state.isEditMode"
                                :pt="{ button: { class: ['py-0 px-2 bg-[#e5e7eb] border rounded-md m-0.5 w-[89px] text-sm'] }, }"
                                class="toss-decision bg-[#e5e7eb] rounded-md " />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-2 h-full ">
                <div class="grid grid-cols-2">
                    <div class="col-span-1 h-fit border-r mt-4 px-2">
                        <div class="flex md:flex-row flex-col items-center"
                            :class="!state.isValid && !match.team1.team.id ? 'pt-2' : ''">
                            <div class="text-center w-full min-w-fit h-6 min-h-min relative">
                                <span v-if="!state.isValid && !match.team1.team.id"
                                    class="text-red-500 text-xs pl-1 flex w-full justify-center absolute top-[-17px] font-normal">
                                    Please select a team
                                </span>
                                <Dropdown v-model="match.team1.team" :options="teams" filter optionLabel="name"
                                    placeholder="Team One" @change="teamSelected(true); updateName()"
                                    class="text-center rounded-md border-2 shadow-none w-full min-w-fit h-6"
                                    :disabled="!state.isEditMode" />
                            </div>
                            <div class="flex items-center md:mt-0 mt-1 w-1/3 justify-center">
                                <label for="homeTeam"
                                    class="font-bold block pb-0.5 w-1/3 pr-2 text-center ml-2 min-w-max">Home
                                    Team</label>
                                <Checkbox v-model="match.team1.homeTeam" inputId="homeTeam"
                                    :disabled="!state.isEditMode" :binary="true"
                                    @change="if (match.team1.homeTeam) match.team2.homeTeam = false;" />
                            </div>
                        </div>
                        <PickList v-model="playersTeamOne" dataKey="id" breakpoint="800px" class="m-4 "
                            :class="!state.isEditMode ? 'isDisabled' : ''" :show-source-controls="false"
                            :show-target-controls="false" :pt:movetotargetbutton:root:disabled="!state.isEditMode"
                            :pt:moveToSourceButton:root:disabled="!state.isEditMode"
                            :pt:moveAllToSourceButton:root:disabled="!state.isEditMode">
                            <template #sourceheader> <span class="font-bold">Team Squad</span> </template>
                            <template #targetheader>
                                <span class="font-bold">Playing
                                    <span v-if="playersTeamOne[1]">: {{ playersTeamOne[1].length }}</span>
                                </span>
                            </template>
                            <template #item="slotProps">
                                <div
                                    class="flex flex-wrap p-0.5 border-b border-solid align-items-center gap-1 players">
                                    <span class="font-semibold text-sm">{{ slotProps.item.name }}</span>
                                </div>
                            </template>
                        </PickList>
                        <div class="flex mb-4">
                            <label for="dayNight" class="font-bold block mb-2 w-1/3 text-center ml-2 min-w-max">Captain
                            </label>
                            <Dropdown v-model="teamOneCaptain" :options="playersTeamOne[1]" filter optionLabel="name"
                                placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2"
                                :disabled="!state.isEditMode" />
                        </div>
                        <div class="flex mb-4">
                            <label for="vice" class="font-bold block mb-2 w-1/3 text-center ml-2 min-w-max">Vice-Captain
                            </label>
                            <Dropdown v-model="teamOneViceCaptain" :options="playersTeamOne[1]" filter
                                optionLabel="name" placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2"
                                :disabled="!state.isEditMode" />
                        </div>
                        <div class="flex mb-4">
                            <label for="dayNight" class="font-bold block mb-2 w-1/3 text-center ml-2 min-w-max">Wicket
                                Keeper
                            </label>
                            <Dropdown v-model="teamOneKeeper" :options="playersTeamOne[1]" filter optionLabel="name"
                                placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2"
                                :disabled="!state.isEditMode" />
                        </div>
                    </div>
                    <div class=" col-span-1 mt-4 px-2">
                        <div class="flex md:flex-row flex-col items-center"
                            :class="!state.isValid && !match.team2.team.id ? 'pt-2' : ''">
                            <div class="text-center w-full min-w-fit h-6 min-h-min relative">
                                <span v-if="!state.isValid && !match.team2.team.id"
                                    class="text-red-500 text-xs pl-1 flex w-full justify-center absolute top-[-17px] font-normal">
                                    Please select a team
                                </span>
                                <Dropdown v-model="match.team2.team" :options="teams" filter optionLabel="name"
                                    placeholder="Team Two" @change="teamSelected(false); updateName()"
                                    class="text-center rounded-md border-2 shadow-none w-full min-w-fit h-6"
                                    :disabled="!state.isEditMode" />
                            </div>
                            <div class="flex items-center md:mt-0 mt-1 w-1/3 justify-center">
                                <label for="homeTeam"
                                    class="font-bold block pb-0.5 w-1/3 pr-2 text-center ml-2 min-w-max">Home
                                    Team</label>
                                <Checkbox v-model="match.team2.homeTeam" inputId="homeTeam"
                                    :disabled="!state.isEditMode" :binary="true"
                                    @change="if (match.team2.homeTeam) match.team1.homeTeam = false;" />
                            </div>
                        </div>
                        <PickList v-model="playersTeamTwo" dataKey="id" breakpoint="800px" class="m-4 "
                            :class="!state.isEditMode ? 'isDisabled' : ''" :show-source-controls="false"
                            :show-target-controls="false" :pt:movetotargetbutton:root:disabled="!state.isEditMode"
                            :pt:moveToSourceButton:root:disabled="!state.isEditMode"
                            :pt:moveAllToSourceButton:root:disabled="!state.isEditMode">
                            <template #sourceheader> <span class="font-bold">Team Squad</span></template>
                            <template #targetheader>
                                <span class="font-bold">Playing
                                    <span v-if="playersTeamTwo[1]">: {{ playersTeamTwo[1].length }}</span>
                                </span>
                            </template>
                            <template #item="slotProps">
                                <div class="flex flex-wrap p-0.5 border-b border-solid  align-items-center gap-1">
                                    <span class="font-semibold text-sm players">
                                        {{ slotProps.item.name }}</span>
                                </div>
                            </template>
                        </PickList>
                        <div class="flex mb-4">
                            <label for="captain" class="font-bold block mb-2 w-1/3 text-center ml-2 min-w-max">Captain
                            </label>
                            <Dropdown v-model="teamTwoCaptain" :options="playersTeamTwo[1]" filter optionLabel="name"
                                placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2"
                                :disabled="!state.isEditMode" />
                        </div>
                        <div class="flex mb-4">
                            <label for="vice" class="font-bold block mb-2 w-1/3 text-center ml-2 min-w-max">Vice-Captain
                            </label>
                            <Dropdown v-model="teamTwoViceCaptain" :options="playersTeamTwo[1]" filter
                                optionLabel="name" placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2"
                                :disabled="!state.isEditMode" />
                        </div>
                        <div class="flex mb-4">
                            <label for="keeper" class="font-bold block mb-2 w-1/3 text-center ml-2 min-w-max">Wicket
                                Keeper
                            </label>
                            <Dropdown v-model="teamTwoKeeper" :options="playersTeamTwo[1]" filter optionLabel="name"
                                placeholder=""
                                class="text-center rounded-md border-2 shadow-none w-2/3 min-w-fit h-6 mx-2"
                                :disabled="!state.isEditMode" />
                        </div>
                    </div>

                    <!-- Umpires -->
                    <div class=" col-span-2 m-4 border-2 border-[#e5e7eb] rounded-lg border-solid p-2 pb-0.5">
                        <div class="flex flex-wrap boundary">
                            <div class="w-1/2 flex justify-around p-0.5 pb-2">
                                <label class="font-bold text-center block min-w-max w-28">Match Referee:
                                    <span v-if="!state.isValid && !match.umpires.matchReferee.id"
                                        class="text-red-500 text-xs pl-1 flex w-full justify-center font-normal">
                                        Please fill in this field
                                    </span>
                                </label>
                                <Dropdown v-model="match.umpires.matchReferee"
                                    class="rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center"
                                    placeholder="" :options="umpires" filter optionLabel="name"
                                    :disabled="!state.isEditMode" />
                            </div>
                            <div class="w-1/2 flex justify-around p-0.5 pb-2">
                                <label class="font-bold text-center block min-w-max w-28">Match Umpires:
                                    <span v-if="!state.isValid && match.umpires.matchUmpires.length == 0"
                                        class="text-red-500 text-xs pl-1 flex w-full justify-center font-normal">
                                        Please fill in this field
                                    </span>
                                </label>
                                <MultiSelect v-model="match.umpires.matchUmpires" :showToggleAll="false"
                                    class="rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center"
                                    placeholder="" :options="umpires" filter optionLabel="name"
                                    :disabled="!state.isEditMode" :pt="{ label: { class: ['p-0 pl-1'] } }" />
                            </div>
                            <div class="w-1/2 flex justify-around p-0.5 pb-2">
                                <label class="font-bold text-center block min-w-max w-28">TV Umpire:
                                    <span v-if="!state.isValid && !match.umpires.tvUmpire.id"
                                        class="text-red-500 text-xs pl-1 flex w-full justify-center font-normal">
                                        Please fill in this field
                                    </span>
                                </label>
                                <Dropdown v-model="match.umpires.tvUmpire"
                                    class="rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center"
                                    placeholder="" :options="umpires" filter optionLabel="name"
                                    :disabled="!state.isEditMode" />
                            </div>
                            <div class="w-1/2 flex justify-around p-0.5 pb-2">
                                <label class="font-bold text-center block min-w-max w-28">Reserve Umpire:
                                    <span v-if="!state.isValid && !match.umpires.reserveUmpire.id"
                                        class="text-red-500 text-xs pl-1 flex w-full justify-center font-normal">
                                        Please fill in this field
                                    </span>
                                </label>
                                <Dropdown v-model="match.umpires.reserveUmpire"
                                    class="rounded-md border-2 shadow-none h-6 w-1/2 text-center self-center"
                                    placeholder="" :options="umpires" filter optionLabel="name"
                                    :disabled="!state.isEditMode" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <footer v-if="state.isEditMode" class="w-full flex justify-end">
            <button
                class="border-2 border-[#1f2937] hover:bg-gray-200 text-[#1f2937] font-semibold my-1.5 h-6 pt-0 pb-[1px] px-6 rounded mr-1 items-center flex"
                @click="confirmCancel()">
                Cancel
            </button>
            <button
                class="bg-[#1f2937] hover:bg-slate-500 text-white font-semi my-1.5 h-6 pt-0 pb-[1px] px-6 rounded items-center flex"
                @click="confirmSave()" :disabled="!state.isEditMode">
                Save
            </button>
        </footer>
        <footer v-else class="w-full flex justify-end">
            <button
                class="bg-[#1f2937] hover:bg-slate-500 text-white font-semi my-1.5 h-6 pt-0 pb-[1px] px-6 rounded mr-1 items-center flex"
                @click="state.isEditMode = true; $emit('changeMatchEditState', true)">
                Edit Match
            </button>
        </footer>
    </div>
    <div v-else class="w-full flex justify-center my-8">
        <ProgressSpinner class="w-90 h-90 mb-2" attrs-color-black strokeWidth="5" animationDuration="1s"
            aria-label="Loading" />
    </div>
</template>

<script lang="ts" setup>
import { Ref, ref, onMounted, defineProps, defineEmits } from 'vue'
import { useApiStore } from "../store/api/api";
import { usePlayApiStore } from "../store/api/playApi";
import { useRealtimeApiStore } from "../store/api/realtimeApi";
import { useConfirm } from "primevue/useconfirm";

import InputText from 'primevue/inputtext';
// import InputNumber from 'primevue/inputnumber';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import PickList from 'primevue/picklist';
import SelectButton from 'primevue/selectbutton';
import MultiSelect from 'primevue/multiselect';
import ProgressSpinner from 'primevue/progressspinner';
import { GenderEnum, MatchTypeEnum, ResultEnum, SeasonEnum, PlayerCard, TossDecisionEnum, Match, CountryEnum, Coach, Player, MatchVenue } from '@/models/vscoreModels'

// const api = useApiStore();
// const playApi = usePlayApiStore()
const api = useRealtimeApiStore()
const confirm = useConfirm();
const props = defineProps(['teams', 'venues', 'selectedMatch'])
const emit = defineEmits(['changeMatchEditState', 'exitMatchView', 'save'])

const state = ref({
    isEditMode: false,
    isLoading: true,
    isMatchNew: Object.keys(props.selectedMatch).length == 0,
    isValid: true,
})


const genderOptions = ref(Object.values(GenderEnum).filter((item) => { return isNaN(Number(item)) }));

// const series: Ref<Series[]> = ref([]);
// const matchRules = ref(['50 Over', '2020', 'Test']);
const matchType = ref(Object.values(MatchTypeEnum).filter((item) => { return isNaN(Number(item)) }));
const result = ref(Object.values(ResultEnum).filter((item) => { return isNaN(Number(item)) }));
// const dayNight = ref(['Day', 'Day / Night', 'Night']);
const season = ref(Object.values(SeasonEnum).filter((item) => { return isNaN(Number(item)) }))
const ground:Ref<MatchVenue[]> = ref(props.venues);
const teams = ref(props.teams);

const playersTeamOne: Ref<Player[][]> = ref([[], []])
const playersTeamTwo: Ref<Player[][]> = ref([[], []])

const tossDecisionOptions = ref(Object.values(TossDecisionEnum).filter((item) => { return isNaN(Number(item)) }));

const umpires = ref()

const teamOneCaptain: Ref<Player> = ref({} as Player)
const teamTwoCaptain: Ref<Player> = ref({} as Player)
const teamOneViceCaptain: Ref<Player> = ref({} as Player)
const teamTwoViceCaptain: Ref<Player> = ref({} as Player)
const teamOneKeeper: Ref<Player> = ref({} as Player)
const teamTwoKeeper: Ref<Player> = ref({} as Player)

const emptyMatch: Match = {
    id: '',
    startDate: '',
    matchType: MatchTypeEnum.Test,
    gender: GenderEnum.Male,
    tossDecision: undefined,
    team1: {
        team: {
            id: '',
            name: '',
        },
        players: [],
        coach: <Coach>{},
        homeTeam: false
    },
    team2: {
        team: {
            id: '',
            name: '',
        },
        players: [],
        coach: <Coach>{},
        homeTeam: false
    },
    season: SeasonEnum._202324,
    series: {
        name: '',
    },
    venue: {
        id: '',
        name: '',
        city: '',
        country: CountryEnum.AFG,
        capacity: 0,
    },
    umpires: {
        matchReferee: {
            id: '',
            firstName: '',
            lastName: '',
            name: '',
            gender: GenderEnum.Male,
        },
        matchUmpires: [],
        tvUmpire: {
            id: '',
            firstName: '',
            lastName: '',
            name: '',
            gender: GenderEnum.Male,
        },
        reserveUmpire: {
            id: '',
            firstName: '',
            lastName: '',
            name: '',
            gender: GenderEnum.Male,
        }
    },
    sessions: [],
    result: ResultEnum.Scheduled
}

const match = ref(emptyMatch)

const matchName = ref('')


const tossWinnerOptions = ref([match.value.team1.team, match.value.team2.team]);


onMounted(async () => {
    populate()
    await api.getAllUmpires().then((value) => {
        umpires.value = JSON.parse(value.data).data;
    })
    if (ground.value.length == 0) {
        await api.getAllVenues().then((value) => {
            ground.value = JSON.parse(value.data).data;
        })
    }
    if (teams.value.length == 0) {
        await api.getAllTeams().then((value) => {
            teams.value = JSON.parse(value.data).data;
        })
    }
})

async function populate() {
    state.value.isLoading = true
    if (!state.value.isMatchNew) {
        matchName.value = props.selectedMatch.name
        match.value = JSON.parse(JSON.stringify(props.selectedMatch))
        // match.value.startDate = new Date(match.value.startDate)
        delete match.value.name

        getPlayersTeamOne()
        getPlayersTeamTwo()

        match.value.team1.players.forEach((playerCard: PlayerCard) => {
            playersTeamOne.value[1].push(playerCard.player)
            if (playerCard.isCaptain) teamOneCaptain.value = playerCard.player
            if (playerCard.isViceCaptain) teamOneViceCaptain.value = playerCard.player
            if (playerCard.isWicketkeeper) teamOneKeeper.value = playerCard.player
        })

        match.value.team2.players.forEach((playerCard: PlayerCard) => {
            playersTeamTwo.value[1].push(playerCard.player)
            if (playerCard.isCaptain) teamTwoCaptain.value = playerCard.player
            if (playerCard.isViceCaptain) teamTwoViceCaptain.value = playerCard.player
            if (playerCard.isWicketkeeper) teamTwoKeeper.value = playerCard.player
        })

        if (match.value.series == undefined) match.value["series"] = { name: "" }

    } else {
        // match.value = emptyMatch
        state.value.isEditMode = true
    }

    tossWinnerOptions.value = [match.value.team1.team, match.value.team2.team];

    // TODO
    // await api.fetchSeriesList().then((value) => {
    //     JSON.parse(value.data).data.forEach((element: any) => {
    //         series.value.push({ name: element["matches.series"] })
    //     });
    // })
    state.value.isLoading = false
}

const confirmSave = () => {
    validate()
    if (state.value.isValid) {
        confirm.require({
            message: 'Confirm to save',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Cancel',
            acceptLabel: 'Save',
            accept: () => {
                state.value.isEditMode = false;
                emit('changeMatchEditState', false)
                save()
            }
        });
    }
};

const confirmCancel = () => {
    confirm.require({
        message: 'Are you sure you want to cancel? Your changes will be lost',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
            state.value.isEditMode = false;
            emit('changeMatchEditState', false)
            if (Object.keys(props.selectedMatch).length !== 0) {
                populate()
            } else {
                emit('exitMatchView')
            }
        }
    });
};

function validate() {
    state.value.isValid = true
    if (!match.value.startDate) state.value.isValid = false
    if (!match.value.venue.id) state.value.isValid = false
    if (!match.value.team1.team.id) state.value.isValid = false
    if (!match.value.team2.team.id) state.value.isValid = false
    if (!match.value.umpires.matchReferee.id) state.value.isValid = false
    if (match.value.umpires.matchUmpires.length == 0) state.value.isValid = false
    if (!match.value.umpires.tvUmpire.id) state.value.isValid = false
    if (!match.value.umpires.reserveUmpire.id) state.value.isValid = false
}

async function getPlayersTeamOne() {
    playersTeamOne.value = [[], []]
    let teamSquad: Player[] = [];
    await api.getSquadByTeamId(match.value.team1.team.id).then((value) => {
        teamSquad = JSON.parse(value.data).data;
        teamSquad.forEach((player: Player) => {
            let playerAlreadyPlaying = false
            match.value.team1.players?.forEach((playerCard: PlayerCard) => {
                if (playerCard.player.id == player.id) {
                    playerAlreadyPlaying = true
                }
            })
            if (!playerAlreadyPlaying) {
                playersTeamOne.value[0].push(player)
            }
        })
    })


}

async function getPlayersTeamTwo() {
    playersTeamTwo.value = [[], []]
    let teamSquad: Player[] = [];
    await api.getSquadByTeamId(match.value.team2.team.id).then((value) => {
        teamSquad = JSON.parse(value.data).data;
        teamSquad.forEach((player: Player) => {
            let playerAlreadyPlaying = false
            match.value.team2.players?.forEach((playerCard: PlayerCard) => {
                if (playerCard.player.id == player.id) {
                    playerAlreadyPlaying = true
                }
            })
            if (!playerAlreadyPlaying) {
                playersTeamTwo.value[0].push(player)
            }
        })
    })


}

function teamSelected(isTeamOne: boolean) {
    if (isTeamOne) {
        match.value.team1.coach = <Coach>{}
        match.value.team1.homeTeam = false
        match.value.team1.players = []
        getPlayersTeamOne()
    } else {
        match.value.team2.coach = <Coach>{}
        match.value.team2.homeTeam = false
        match.value.team2.players = []
        getPlayersTeamTwo()
    }

    tossWinnerOptions.value = [match.value.team1.team, match.value.team2.team];

}

function updateName() {
    if (match.value.startDate !== '' && match.value.team1.team.name !== '' && match.value.team2.team.name !== '' && match.value.venue.name !== '') {
        matchName.value = match.value.team1.team.name + " vs " + match.value.team2.team.name + " at " + match.value.venue.name + " on " + (new Date(match.value.startDate)).toUTCString()
    }
}

async function save() {
    // TODO
    // Are my substitutes those not picked from the squad - or should i have a substitutes dropdown list?
    // Add selected players to match team
    if (state.value.isMatchNew) {
        playersTeamOne.value[1].forEach((player: Player) => {
            let newPlayerCard = {} as PlayerCard;
            newPlayerCard.player = player
            newPlayerCard.isCaptain = teamOneCaptain.value.id == player.id ? true : false
            newPlayerCard.isViceCaptain = teamOneViceCaptain.value.id == player.id ? true : false
            newPlayerCard.isWicketkeeper = teamOneKeeper.value.id == player.id ? true : false
            newPlayerCard.isSubstitute = false
            match.value.team1.players.push(newPlayerCard)
        });
        playersTeamTwo.value[1].forEach((player: Player) => {
            let newPlayerCard = {} as PlayerCard;
            newPlayerCard.player = player
            newPlayerCard.isCaptain = teamTwoCaptain.value.id == player.id ? true : false
            newPlayerCard.isViceCaptain = teamTwoViceCaptain.value.id == player.id ? true : false
            newPlayerCard.isWicketkeeper = teamTwoKeeper.value.id == player.id ? true : false
            newPlayerCard.isSubstitute = false
            match.value.team2.players.push(newPlayerCard)
        });

        // Create new match object to change values into ID's were needed
        const newMatch: Ref<any> = ref(JSON.parse(JSON.stringify(match.value)))

        newMatch.value.team1.players.forEach((playerCard: any) => {
            playerCard["id"] = playerCard.player.id
            delete playerCard.player
        });
        newMatch.value.team2.players.forEach((playerCard: any) => {
            playerCard["id"] = playerCard.player.id
            delete playerCard.player
        });

        delete newMatch.value.venue
        newMatch.value["venueId"] = match.value.venue.id

        delete newMatch.value.umpires.matchReferee
        newMatch.value.umpires["matchRefereeId"] = match.value.umpires.matchReferee.id

        delete newMatch.value.umpires.tvUmpire
        newMatch.value.umpires["tvUmpireId"] = match.value.umpires.tvUmpire.id

        delete newMatch.value.umpires.reserveUmpire
        newMatch.value.umpires["reserveUmpireId"] = match.value.umpires.reserveUmpire.id

        delete newMatch.value.umpires.matchUmpires
        newMatch.value.umpires["matchUmpireIds"] = []
        match.value.umpires.matchUmpires.forEach((umpire: any) => {
            newMatch.value.umpires["matchUmpireIds"].push(umpire.id)
        });

        delete newMatch.value.team1.team
        newMatch.value.team1["teamId"] = match.value.team1.team.id

        delete newMatch.value.team2.team
        newMatch.value.team2["teamId"] = match.value.team2.team.id

        delete newMatch.value.team1.coach
        newMatch.value.team1["coachId"] = "FAKEID"

        delete newMatch.value.team2.coach
        newMatch.value.team2["coachId"] = "FAKEID"


        // let newMatchId;
        // API Call
        // await api.createMatch(newMatch.value).then((response: any) => {
        //     state.value.isMatchNew = false
        //     console.log("location: " + response)
        //     // newMatchId = response.split("/")[1]
        // })
        // match.value.venue = tempVenue
        // newMatchId = "FAKEID"
    } else {
        // TODO - update match
    }
    emit('save')
}

</script>

<style>
.p-picklist-buttons .p-button:nth-child(2) {
    display: none;
}

.p-picklist-buttons {
    padding: 2px;
    margin: 0px;
}

.p-picklist-header {
    padding: 0.5rem;
    line-height: 1rem;
    background-color: #f9fafb;
}

.p-picklist-item {
    padding: 0rem 0.25rem;
}

.bowling-end .p-button {
    padding: 0px;
}

.bowling-end .p-button .p-button-label {
    padding: 1px 4px;
}

.p-picklist-list-wrapper {
    border: 1px solid #e5e7eb;
    border-radius: 5px;
}

.p-picklist-list {
    scrollbar-width: thin;
}

.p-picklist-source-list {
    max-height: 31rem;
}

.toss-decision {
    max-width: min-content;
    display: flex;
    flex-wrap: nowrap;
}

.toss-decision .p-highlight {
    background-color: white;
    color: black;
}

#matchId {
    width: 90%;
    text-align: center;
}

::-webkit-input-placeholder {
    /* WebKit browsers */
    color: red;
    opacity: 1 !important;
}

.p-component:disabled {
    opacity: 1;
}

.isDisabled li {
    background-color: inherit;
}

.boundary input {
    overflow: hidden;
    box-shadow: none;
    width: inherit;
}

.p-checkbox.p-highlight .p-checkbox-box {
    background-color: #1f2937;
}
</style>